import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30c3915a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = {
  id: "navbarNav",
  class: "collapse navbar-collapse"
}
const _hoisted_5 = { class: "navbar-nav" }
const _hoisted_6 = { class: "navbar-nav ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/notebook"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.notebook')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/practice"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.practice')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/import"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.import')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/export"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.export')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/delete"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.delete')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/language-selection"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.language')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, _toDisplayString(_ctx.$t('nav.logout')), 1)
        ])
      ])
    ])
  ]))
}